export interface DuesRatesRow {
  id: string;
  productName: string;
  classification: string;
  classificationDescription: string;
  rate_current_year: string | null;
  rate_previous_year: string | null;
  rate_previous_year_2: string | null;
  updatedAt: string | null;
  status: StatusType | null;
  statusMessage: string[];
  finalized: boolean;
}

export enum StatusType {
  WARNING = "warning",
  ERROR = "error"
}

export type Variables = {
  kind: string;
  classification?: string[];
  search?: string;
};

export type ContextType = {
  setErrorMessage: (message: string) => void;
};
